import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap-v5'
import axios from 'axios'
//const type = parse(history.location.search).type as string;

import { setCompanyVerificationMethod, setEntityDataPartner, setKycStep } from './redux/actions'
import { CompanyProfile } from '../../../svg/CompanyProfileIcon'
import { BankIcon } from '../../../svg/BankIIcon'
import { Step3Icon } from '../../../svg/step3'

interface Props {
  show: boolean
  handleClose: any
  // goToStep:any;
}

const CompanyVerification: FC<Props> = ({
  show,
  handleClose,
}: // goToStep
any) => {
  const dispatch = useDispatch()
  
  const history: any = useHistory()
  const loanApplicationId = localStorage.getItem('loanApplicationId')
  const loanApplication = useSelector((state: any) => state.kycApplication.loanApplication)
  const companyVerificationMethod = useSelector(
    (state: any) => state.kycApplication.companyVerificationMethod
  )

  const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false)

  const connectMyInfo = async () => {
    localStorage.setItem('loanApplicationId', loanApplication?.id)
    localStorage.setItem('singpass', 'myinfobiz')

    // const singPassUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://iris-dev.credilinq.ai/api/alexi-singpass';
    const singPassUrl = process.env.REACT_APP_SINGPASS_URL || 'http://localhost:3002'

    const getEnv = await axios.get(singPassUrl + '/getEnv').then((response) => response.data)

    const state = Math.floor(Math.random() * 100000)
    //todo change the redirect url to this page getEnv
    const { clientId, redirectUrl, attributes, purpose, authApiUrl } = getEnv
    const authoriseUrl: any = `${authApiUrl}?client_id=${clientId}&attributes=${attributes}&purpose=${purpose}&state=${encodeURIComponent(
      state
    )}&redirect_uri=${redirectUrl}`
    ;(window as any).location = authoriseUrl
  }

  const submitProfileVerification = async () => {

    if (companyVerificationMethod === 1) {
      localStorage.setItem('companyVerificationMethod', companyVerificationMethod.toString())
      connectMyInfo()
    } else {
      dispatch(setKycStep(2))
      localStorage.setItem('companyVerificationMethod', companyVerificationMethod.toString())

      if (
        loanApplicationId &&
        ['stage', 'sandbox', 'dev'].includes(localStorage.getItem('env') as string)
      ) {
        ;(async () => {
          const response = await import(
            `../../../utils/custom/${loanApplication.companyUEN}/step3.json`
          )
          const eligibilityData: any = response.default
          if (eligibilityData) {
            // Dispatch the action to update the loan eligibility in the Redux store
            dispatch(setEntityDataPartner(eligibilityData))
          }
        })()
        history.replace(`sg-kyb-nets/${loanApplication.id}?step=3`)
      } else {
        history.replace(`sg-kyb-nets/${loanApplication.id}?step=3`)
      }
    }
    handleClose()
  }

  return (
    <>
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        show={show}
        centered // Bootstrap's built-in class for centering modals
      >
        <div className='modal-content w-100 px-8'>
          <div className='d-flex flex-column align-items-center justify-content-center pt-6'>
            <CompanyProfile className='mb-4' />
            <h2 className='section-heading m-0 mt-4 mb-2'>Verify Company Profile</h2>
          </div>
          <div className='d-block mx-5 my-5'>
            {!showErrorMessage ? (
              <div className='d-flex align-items-center min-h-145px flex-column'>
                <div className='fv-row fv-plugins-icon-container w-100'>
                  <div className='row'>
                    <div className='col-lg-12 loan-application '>
                      <div className='text-center mb-8'>
                        <p
                          className='text-color-10 fw-normal mb-0'
                          style={{
                            fontSize: '15px',
                            lineHeight: '22px',
                          }}
                        >
                          We will verify your business details using SingPass.
                        </p>
                      </div>

                      <div
                        className='d-flex align-items-center p-5 mb-7'
                        style={{
                          background: 'var(--primary-light-color)',
                          border: '1px solid var(--primary-light-color)',
                          borderRadius: '12px',
                        }}
                      >
                        <div
                          className='d-flex align-items-center justify-content-center me-4'
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            background: '#FFE8F1',
                            flexShrink: 0,
                          }}
                        >
                          <Step3Icon color='var(--primary-icon-color)' />
                        </div>

                        <div className='d-flex flex-column'>
                          <span
                            className='fw-bold text-dark'
                            style={{
                              fontSize: '16px',
                              fontWeight: '800',
                              lineHeight: '24px',
                            }}
                          >
                            {loanApplication.loanEligibility.companyName}
                          </span>

                          <span
                            className='text-muted'
                            style={{
                              fontSize: '14px',
                              marginTop: '2px',
                            }}
                          >
                            UEN: {loanApplication.companyUEN}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            
              <div className='d-flex align-items-center justify-content-center min-h-145px w-100 flex-column gap-1'>
                <div className='fv-row fv-plugins-icon-container w-100'>
                  <div className='row'>
                    <div className='col-lg-12 loan-application'>
                      <label className={`
                        btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center mb-3 verify-profile verify-profile-click 
                      `}>
                        <BankIcon color='var(--primary-color)' />
                        <span className='d-block fw-bold text-start ms-4'>
                          <span className='text-primary fw-bold d-block fs-4 mb-0 font-secondary'>
                           Verify with MyInfo Business using SingPass
                          </span>
                          <span className='fw-light text-color-10 fs-6'>
                            Takes about 1-2 minutes
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            ) : (showErrorMessage &&
              <div className='d-flex align-items-center justify-content-center min-h-145px'>
                <div className='text-center'>
                  <p className='text-dark'>
                    Share your{' '}
                    <strong className='fs-5 text-dark'>
                      Application Number: {loanApplication?.applicationNumber}{' '}
                    </strong>{' '}
                    and{' '}
                    <strong className='fs-5 text-dark'>
                      Company Name: {loanApplication?.loanEligibility?.companyName}
                    </strong>{' '}
                    for quick reference to support.
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className='d-flex flex-column gap-5 flex-center mx-5 my-7'>
            {(
              <>
                {(
                  <button
                    className='button button-primary w-100'
                    onClick={() => {
                      submitProfileVerification()
                    }}
                  >
                    Verify
                  </button>
                )}
                <>
                  <button
                    className='button button-outline-back w-100'
                    onClick={() => {
                      dispatch(setKycStep(2))
                      dispatch(setCompanyVerificationMethod(1))
                    }}
                  >
                    Back
                  </button>
                </>
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CompanyVerification
